import _ from 'lodash';
import $param from 'jquery-param';
import Url from './Url';

export default class UrlBrowser {
  constructor() {
    this.url = null;
    this.updateUrl();
  }

  updateUrl() {
    this.url = new Url(window.location);
  }

  /**
   * Метод для получения значения параметра по ключу.
   * @param param
   */
  getParamURLBrowser(param) {
    return this.url.paramsObj[param];
  }

  /**
   * Метод добавляет параметры в URL баузера
   * @param objParams {object} - объект параметров, которые нужно добавить.
   * При совпадении параметров, старые перезаписываются глубокой рекурсий.
   */
  setParamURLBrowser(objParams) {
    const paramsObjOld = this.url.paramsObj;
    const paramsObjNew = _.merge(paramsObjOld, objParams);
    const paramsSrtNew = $param(paramsObjNew);
    const newUrl = `${this.url.pathname}?${paramsSrtNew}${this.url.hash}`;
    const { history } = window;
    history.replaceState(null, '', newUrl);
    this.updateUrl();
  }

  /**
   * Метод удаляет переданные параметры из URL баузера
   * @param params {array} - массив параметров, которые нужно удалить из URL
   */
  removeParam(params) {
    const { paramsObj } = this.url;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < params.length; i++) {
      const param = params[i];
      if (typeof paramsObj[param] !== 'undefined') {
        delete paramsObj[param];
      }
    }
    const paramsSrtNew = $param(paramsObj);
    const newUrl = `${this.url.pathname}?${paramsSrtNew}${this.url.hash}`;
    const { history } = window;
    history.replaceState(null, '', newUrl);
    this.updateUrl();
  }
}
